import { Link } from 'react-router';
import { EmptyState, Icon, PageHeader, type NavItem } from '@saas/ui';
import { useNavModel } from '../shell/nav.js';

function AdminTile({ item }: { item: NavItem }) {
  return (
    <li>
      <Link
        to={item.to}
        className="flex min-h-28 flex-col rounded-card border border-[var(--card-border-color)] bg-card p-5 shadow-elev-1 transition-colors hover:bg-sunken"
      >
        <span className="flex items-center justify-between">
          <Icon name={item.icon} size={28} />
          <Icon name="chevron_right" size={24} className="text-fg-tertiary" />
        </span>
        <span className="mt-3 text-headline wrap-name">{item.label}</span>
        {item.description ? <span className="mt-1 text-caption text-fg-secondary">{item.description}</span> : null}
      </Link>
    </li>
  );
}

/** 権限のある管理機能を一つの入口にまとめる。項目の権限判定は useNavModel と共通。 */
export function AdminHomePage() {
  const { admin } = useNavModel();
  return (
    <>
      <PageHeader title="管理" description="会社と業務機能の管理メニューです" />
      {admin.length > 0 ? (
        <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {admin.map((item) => <AdminTile key={item.to} item={item} />)}
        </ul>
      ) : (
        <EmptyState icon="shield" title="利用できる管理機能はありません" description="管理権限が付与されると、ここにメニューが表示されます" />
      )}
    </>
  );
}
